import { Link } from 'react-router-dom';
import * as eva from 'eva-icons';
import styled, { useTheme } from 'styled-components';
import { useEffect } from 'react';

import ListItem from './ListItem';
import Icon from './Icon';
import Box from './layout/Box';
import Text from './Text';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';

const StyledTitle = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0;
  margin: 0;
`;

const ProductBookListItem = ({ book }) => {
  useEffect(() => {
    eva.replace();
  }, []);

  const theme = useTheme();

  const isLoggedIn = useSelector((state) => !!state.auth.cognitoUser);

  const { primaryColor, secondaryColor, thirdColor } = theme.colors;

  // random number between 0 and 2
  const random = Math.floor(Math.random() * 3);
  const colors = [primaryColor, secondaryColor, thirdColor];
  const iconColor = colors[random < 3 ? random : 2];

  const now = DateTime.local();
  const createdAt = DateTime.fromMillis(parseInt(book.updatedAt, 10));

  let dayText = createdAt.setLocale('sv-SE').toRelativeCalendar();
  const fromToday = now.hasSame(createdAt, 'day');
  const dayDiff = now.diff(createdAt, 'days').toObject().days;

  // make first letter uppercase
  dayText = dayText.charAt(0).toUpperCase() + dayText.slice(1);

  if (dayDiff > 60) {
    dayText = createdAt.setLocale('sv-SE').toFormat('yyyy-MM-dd');
  }
  return (
    <Link
      key={`new-book-${book.id}`}
      to={`/book?i=${book.id}`}
      style={{ color: 'black' }}
    >
      <ListItem
        style={{
          borderBottom: '2px solid #e7e7e7',
        }}
        className="mb-3 px-2 pb-3 align-items-center"
        key={book.id.toString()}
        before={
          <Box
            className="align-items-center me-2 justify-content-center"
            style={{
              width: 50,
              height: 50,
              border: '2px solid #e7e7e7',
            }}
            borderRadius={999}
          >
            <Icon name="person-outline" color={iconColor} size={26} />
          </Box>
        }
        after={
          <Box
            style={{
              height: 'inherit',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box>
              <Text
                color="errorColor"
                style={{
                  fontWeight: 600,
                }}
              >
                {book.price} kr
              </Text>
            </Box>
            <Icon
              name="chevron-right-outline"
              color={theme.colors.mediumGrayColor}
              size={32}
            />
          </Box>
        }
      >
        <Box className="h-100 flex-column justify-content-center">
          {isLoggedIn ? (
            <StyledTitle>{book.user.name}</StyledTitle>
          ) : (
            <Box className="align-items-center">
              <StyledTitle>Medlem</StyledTitle>
              <Box className="ms-1">
                <Icon
                  name="lock"
                  color={theme.colors.mediumGrayColor}
                  size={16}
                />
              </Box>
            </Box>
          )}

          <Box className="mt-1 align-items-center">
            <Icon
              name="calendar-outline"
              color={theme.colors.mediumGrayColor}
              size={16}
            />
            <Text variant="listItemTag" className="ms-1">
              {dayText} {fromToday && createdAt.toFormat('HH:mm')}
            </Text>
          </Box>
        </Box>
      </ListItem>
    </Link>
  );
};

export default ProductBookListItem;
